import { ITenantBids } from 'app/shared/model/tenant-bids.model';
import { ShipmentStatus } from 'app/shared/model/enumerations/shipment-status.model';

export interface ITenantBidShipment {
  id?: string;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  shipmentStatus?: keyof typeof ShipmentStatus;
  carrier?: string | null;
  carrierMobileNo?: string | null;
  tenantBid?: ITenantBids | null;
}

export const defaultValue: Readonly<ITenantBidShipment> = {
  active: false,
};
